import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import { getUserColor, getShortLetters } from '../../utils/function';
import Editor from 'react-simple-wysiwyg';
import axios from 'axios';
import { UTILS } from '../../constants';
import { toast } from 'react-toastify';
import { TbFileTypeZip } from 'react-icons/tb';
import { BsFiletypeDoc } from 'react-icons/bs';
import { GrDocumentPdf } from 'react-icons/gr';
import { GrDocumentTxt } from 'react-icons/gr';
import { PiFilePptLight } from 'react-icons/pi';
import { BsFiletypeXls } from 'react-icons/bs';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import TaggableEditor from './testActivity/index';
// import Select2 from 'react-select2-wrapper';
// import 'select2/dist/css/select2.min.css';
import Select from 'react-select';
import { useSelector } from 'react-redux';

export const Activity = ({
  cardDetail,
  fetchCardDetail,
  attachmentsFile,
  value,
  people_users,
  Commentdata,
}) => {
  let getDataLocalStorage = JSON.parse(localStorage.getItem('userDetails'));
  let [activityDate, setActivityData] = useState([]);
  // console.log('Activity', activityDate);

  const [html, setHtml] = useState('');
  const [dataEditorAdded, setDataEditorAdded] = useState(``);
  const [showEditor, setShowEditor] = useState(true);
  const [editorId, setEditorId] = useState(null);
  const [dataId, setDataId] = useState(null);
  let [userDetailData, setUserDetails] = useState(null);
  let [hideActivity, setHideActivity] = useState(true);
  let [members, setMembers] = useState(null);
  let [checkComment, setCheckComment] = useState(Commentdata);

  const [mentionList, setMentionList] = useState([]);
  const [isMentioning, setIsMentioning] = useState(false);
  const [mentionStart, setMentionStart] = useState(null); // Track where @ starts
  const [cursorPos, setCursorPos] = useState(0); // Track cursor position
  const editorRef = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const [people, setPeople] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [Tags, setTags] = useState([]);

  let anchorCommentData = useSelector(state=>state.comment);
  console.log('new anchorCommentData ---> ',anchorCommentData);

  useEffect(() => {
    const filteredActivities = cardDetail?.activities?.filter(activity => activity.activity === "attached");
    const attachment = filteredActivities?.map(activity => activity.attachment?.original_name);
    setAttachments(attachment)
  }, []);

  useLayoutEffect(() => {
    setUserDetails(getDataLocalStorage);
  }, []);

  useEffect(() => {
    setActivityData(cardDetail?.activities);
    // setMembers(cardDetail?.assigned_users);
    const combinedUsers = [
      ...(cardDetail?.assigned_users || []),
      ...(cardDetail?.unassigned_users || []),
    ];

    setMembers(combinedUsers);
  }, [cardDetail]);

  // useEffect(() => {
  //   setAssigned_users(cardDetail?.assigned_users);
  // }, [cardDetail?.assigned_users]);

  // Edit Editor Tag

  // Sample list of persons to tag
  // const people = ["John Doe", "Jane Smith", "Alice Johnson", "Bob Brown"];
  useEffect(() => {
    if(Commentdata != null){
      setShowEditor(false);
    }
  }, [Commentdata]);
  
  useEffect(() => {
    setPeople(people_users);
  }, []);

  const calculateCursorPosition = () => {
    if (!editorRef.current) return; // Check if the editor reference exists

    const selection = window.getSelection();
    if (!selection.rangeCount) return;

    const range = selection.getRangeAt(0).cloneRange();
    const rect = range.getBoundingClientRect();
    const editorRect = editorRef.current.getBoundingClientRect();

    if (rect) {
      const editorStyle = window.getComputedStyle(editorRef.current);
      const editorPaddingLeft = parseFloat(editorStyle.paddingLeft);
      const editorPaddingTop = parseFloat(editorStyle.paddingTop);

      setDropdownPosition({
        top:
          rect.bottom - editorRect.top + window.scrollY - editorPaddingTop + 5,
        left: rect.left - editorRect.left + window.scrollX - editorPaddingLeft,
      });
    }
  };

  const handleEditorChange = (e) => {
    const updatedContent = e.target.value;
    setHtml(e.target.value);
    const atSymbolIndex = updatedContent.lastIndexOf('@');
    const atSymbolIndexhash = updatedContent.lastIndexOf('#');

    // If "@" is present and followed by valid characters (letters), show the dropdown
    if (
      atSymbolIndex !== -1 &&
      (atSymbolIndex === 0 ||
        /[\s]/.test(updatedContent.charAt(atSymbolIndex - 1))) && // Check for space or start
      /^[a-zA-Z]*$/.test(updatedContent.slice(atSymbolIndex + 1)) // Check that "@" is followed by letters
    ) {
      const selection = window.getSelection();
      const range = selection.getRangeAt(0);
      const rect = range.getBoundingClientRect();

      // Calculate cursor position
      const cursorPosition = {
        top: rect.top + window.scrollY, // Adjust for page scroll
        left: rect.left + window.scrollX, // Adjust for page scroll
      };
      setDropdownPosition([cursorPosition.top, cursorPosition.left]);
      // calculateCursorPosition();
      setTags("@")
      setShowDropdown(true);
      setSuggestions(people); // Populate dropdown with people suggestions
    }else if(
      atSymbolIndexhash !== -1 &&
      (atSymbolIndexhash === 0 ||
        /[\s]/.test(updatedContent.charAt(atSymbolIndexhash - 1))) && // Check for space or start
      /^[a-zA-Z]*$/.test(updatedContent.slice(atSymbolIndexhash + 1)) // Check that "@" is followed by letters
    ){
      const selection = window.getSelection();
      const range = selection.getRangeAt(0);
      const rect = range.getBoundingClientRect();

      // Calculate cursor position
      const cursorPosition = {
        top: rect.top + window.scrollY, // Adjust for page scroll
        left: rect.left + window.scrollX, // Adjust for page scroll
      };
      setDropdownPosition([cursorPosition.top, cursorPosition.left]);
      // calculateCursorPosition();
      setTags("#")
      setShowDropdown(true);
      setSuggestions(attachments); // Populate dropdown with people suggestions
    } else {
      setShowDropdown(false); // Close dropdown if not tagging
    }
  };

  const handleSelectPerson = (person) => {
    const atSymbolIndex = html.lastIndexOf('@');
    const atSymbolIndexhash = html.lastIndexOf('#');

    // Insert selected person with proper formatting
    if(Tags == "@"){
      const newContent =
        html.substring(0, atSymbolIndex) +
        `<span class="tag_user" contenteditable="false">@${person}</span>&nbsp;` +
        html.substring(atSymbolIndex + 1); // Maintain the rest of the content
  
      setHtml(newContent);
      setShowDropdown(false); // Close dropdown after selection
    }else if(Tags == "#"){

      const foundActivity = cardDetail?.activities?.find(
        activity => activity.attachment?.original_name === person
      );
      // Get the original_name of the found activity
      const attachmentOriginalName = foundActivity?.attachment?.file_name;
      const url =  isRecent(foundActivity?.attachment?.created_at , 10)
      ? UTILS.images_url + "original/" + attachmentOriginalName
      : UTILS.temp_image_url + "original/" + attachmentOriginalName;
      const newContent =
      html.substring(0, atSymbolIndexhash) +
        `<a href="${url}"><span class="tag_user" contenteditable="false">#${person}</span></a>&nbsp;` +
        html.substring(atSymbolIndexhash + 1);
      setHtml(newContent);
      setShowDropdown(false); // Close dropdown after selection
    }

    // Ensure caret is placed outside the inserted span for further tagging or typing
    // setTimeout(() => {
    //   const editor = editorRef.current;
    //   if (editor) {
    //     const range = document.createRange();
    //     const selection = window.getSelection();

    //     if (editor.lastChild) {
    //       range.setStartAfter(editor.lastChild); // Move caret after the last child (after the span)
    //       range.collapse(true);
    //       selection.removeAllRanges();
    //       selection.addRange(range);
    //     }
    //   }
    // }, 0);
    setTimeout(() => {
      const editor = editorRef.current;
      if (editor) {
        const range = document.createRange();
        const selection = window.getSelection();
        range.setStartAfter(editor.lastChild);
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }, 0);
  };

  const handleSelectChange = (e) => {
    const selectedPerson = e.value;
    handleSelectPerson(selectedPerson);
  };
  // function onChange(e) {

  //   setHtml(e.target.value);

  // }
  const isImage = (fileName) => {
    if (!fileName) return false; // Check if fileName is undefined or null
    const imageExtensions = ['image'];
    const extension = fileName.split('/')[0];
    return imageExtensions.includes(extension);
  };

  // Helper function to determine the icon for non-image files
  const getFileIcon = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase();
    switch (extension) {
      case 'pdf':
        return '📄'; // You can use FontAwesome or other icon libraries for better icons
      case 'doc':
      case 'docx':
        return '📃';
      case 'xls':
      case 'xlsx':
        return '📊';
      default:
        return '📁'; // Default icon for unknown file types
    }
  };
  const getSpecificId = (id, comment) => {
    // console.log("getSpecificId", id);
    setHtml(comment);
    // Assuming activityData is available in the scope
    const filteredActivities = activityDate.filter(
      (activity) => activity.activity_type === 0
    );
    // console.log("activity", filteredActivities);
    const matchingActivity = filteredActivities.find(
      (activity) => activity.comment && activity.comment.id === id
    );
    // console.log("matchingActivity", matchingActivity);
    if (matchingActivity) {
      setEditorId(id); // Set the editorId to the matched id
      setDataId(id);
    }
  };

  const fetchUpdateComments = async () => {
    // console.log("newDescription", editorId);
    // Create a new DOM parser

    if (html == '') {
      alert('you need to do changes');
    } else {
      try {
        const formData = new FormData();
        formData.append('task_id', cardDetail.id);
        formData.append('comment_id', editorId);
        formData.append('text', html);
        const randomString = Math.random().toString(36).substring(2, 5);

        const response = await axios.post(
          `${UTILS.API_url}board/v1/board-list-cards/comment/update?${randomString}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
              'Content-Type': 'multipart/form-data', // Make sure to set this header for FormData
            },
          }
        );
        // console.log("Updated card description:", response.data);
        //  if(response.success == 200){
        toast.success(response.data.success);
        fetchCardDetail();
        setEditorId(null);
        // setDataId(null);
        setHtml('');

        // setHtml("")
        //  }
        // Handle state update or other logic after successful update
      } catch (error) {
        console.error('Error updating card description:', error);
        // Handle error gracefully
      }
    }
  };
  // console.log("html", html);

  useEffect(() => {
    setDataEditorAdded((dataEditorAdded) =>  dataEditorAdded + ` `+ (anchorCommentData.newComment == null? "" : anchorCommentData.newComment));
  },[anchorCommentData])

  useEffect(() => {
    console.log('---> ',dataEditorAdded);
  },[dataEditorAdded])

  const onChangeAddEditor = (e) => {
    const value = e.target.value;
    const cursorIndex = e.target.selectionStart;
    setDataEditorAdded(value);
    setCursorPos(cursorIndex);

    const textBeforeCursor = value.slice(0, cursorIndex);
    const mentionMatch = textBeforeCursor.match(/@(\w*)$/);

    if (mentionMatch) {
      const searchQuery = mentionMatch[1];
      if (searchQuery.length > 0) {
        setIsMentioning(true);
        setMentionList(
          members
            .filter((member) =>
              member.name.toLowerCase().includes(searchQuery.toLowerCase())
            )
            .map((member) => member.name)
        );
        setMentionStart(cursorIndex - searchQuery.length - 1); // Store where @ starts
      } else {
        setIsMentioning(false);
        setMentionList([]);
      }
    } else {
      setIsMentioning(false);
      setMentionList([]);
    }
  };

  // const handleMentionClick = (name) => {
  //   // Text before the @mention (excluding the @ symbol)
  //   const textBeforeMention = dataEditorAdded.slice(0, mentionStart);

  //   // Find the first space after the @mention to determine where the attached characters end
  //   const mentionEnd = dataEditorAdded.slice(mentionStart).search(/\s|$/);

  //   // Slice out the text after the attached characters (or till the end if no space is found)
  //   const textAfterMention = dataEditorAdded.slice(mentionStart + mentionEnd);

  //   // Combine the text before the mention, the selected name, and the remaining text
  //   const newText = `${textBeforeMention}${name} ${textAfterMention}`;

  //   // Update the editor with the new text
  //   setDataEditorAdded(newText);

  //   // Hide the mention list
  //   setIsMentioning(false);

  //   // Clear the mention list
  //   setMentionList([]);

  //   // Set the cursor position after the inserted name
  //   setCursorPos(mentionStart + name.length + 1);
  // };

  const handleAddDescription = async () => {
    // console.log("dataEditorAdded", dataEditorAdded);
    try {
      const formData = new FormData();
      formData.append('task_id', cardDetail.id);
      formData.append('text', dataEditorAdded);
      const randomString = Math.random().toString(36).substring(2, 5);

      const response = await axios.post(
        `${UTILS.API_url}board/v1/board-list-cards/comment/create?${randomString}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
            'Content-Type': 'multipart/form-data', // Make sure to set this header for FormData
          },
        }
      );
      // console.log("add card description:", response.data);
      //  if(response.success == 200){
      toast.success(response.data.success);
      setShowEditor(true);

      setActivityData([response.data.activity, ...activityDate]);
      setDataEditorAdded();

      //  }
      // Handle state update or other logic after successful update
    } catch (error) {
      console.error('Error updating card description:', error);
      // Handle error gracefully
    }
  };

  const onDeleteFunc = async (comment_id) => {
    try {
      const formData = new FormData();
      formData.append('task_id', cardDetail.id);
      formData.append('comment_id', comment_id);
      const randomString = Math.random().toString(36).substring(2, 5);

      const response = await axios.post(
        `${UTILS.API_url}board/v1/board-list-cards/comment/delete?${randomString}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
            'Content-Type': 'multipart/form-data', // Make sure to set this header for FormData
          },
        }
      );
      // console.log("delete comment description:", response.data);
      const updatedActivityData = activityDate.filter(
        (activity) => !activity.comment || activity.comment.id !== comment_id
      );
      toast.success(response.data.success);
      // const filteredActivities = activityDate.filter(
      //   (activity) => activity.activity_type === 0
      // );
      // let deleteFilter=filteredActivities.filter(activity => activity.comment.id === comment_id)
      setActivityData(updatedActivityData);
      //  if(response.success == 200){
      //  }
      // Handle state update or other logic after successful update
    } catch (error) {
      console.error('Error updating card description:', error);
      // Handle error gracefully
    }
  };

  const showHideAttachment = () => {
    setHideActivity(!hideActivity);
  };
  // console.log('activityDate1', activityDate);

  // useEffect(() => {
  //   Fancybox.bind('[data-fancybox="gallery"]', {});

  //   return () => {
  //     Fancybox.unbind('[data-fancybox="gallery"]');
  //   };
  // }, []);

  const isRecent = (createdAt, limitInMinutes) => {
    // Check if createdAt is defined and is a string
    if (typeof createdAt !== 'string') return false;

    const currentTime = new Date();
    let timeDiffInMillis;

    if (createdAt.includes('second')) {
      const seconds = parseInt(createdAt.split(' ')[0], 10);
      timeDiffInMillis = seconds * 1000; // Convert seconds to milliseconds
    } else if (createdAt.includes('minute')) {
      const minutes = parseInt(createdAt.split(' ')[0], 10);
      timeDiffInMillis = minutes * 60 * 1000; // Convert minutes to milliseconds
    } else {
      const minutes = 50;
      timeDiffInMillis = minutes * 60 * 1000; // Convert minutes to milliseconds
      // return false; // Return false if the format isn't recognized
    }

    const createdTime = new Date(currentTime.getTime() - timeDiffInMillis);
    const differenceInMillis = currentTime - createdTime;

    return differenceInMillis > limitInMinutes * 60 * 1000; // Convert limit to milliseconds
  };

  useEffect(() => {
    // Bind Fancybox after the content has been rendered
    Fancybox.bind("[data-fancybox='gallery']", {
      infinite: false,
    });

    // Cleanup on unmount or when content changes
    return () => {
      Fancybox.destroy();
    };
  }, [value?.comment?.comment]);

  // console.log('attachmentsFileAct_', members && members);
  return (
    <div>
      <div class="des-div-flex">
        <h4 class="description-heading">
          <span class="material-symbols-outlined lg-icon">sort</span>
          Activity
        </h4>
        <button
          href="javascript:void(0);"
          class="btn btn-light att-add activity-detail"
          onClick={showHideAttachment}
        >
          {hideActivity ? 'Hide Activity' : 'Show Activity'}
        </button>
      </div>
      <div className="">
        <div class="coment-div new-comments new-activity-move normal-activity">
          {!cardDetail?.deleted_at &&
            (showEditor ? (
              <>
                <div class="por-small">
                  {userDetailData && (
                    <span
                      class={
                        'member-avatar color' +
                        getUserColor(userDetailData && userDetailData?.name)
                      }
                      title={userDetailData && userDetailData?.name}
                    >
                      {getShortLetters(userDetailData && userDetailData?.name)}
                    </span>
                  )}
                </div>

                <div className="upd-comment-div">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: 'Write a comment here',
                    }}
                    onClick={() => setShowEditor(false)}
                  />
                </div>
              </>
            ) : (
              <div className="sletmem-prof tagSet">
                <div class="por-small">
                  {userDetailData && (
                    <span
                      class={
                        'member-avatar color' +
                        getUserColor(userDetailData && userDetailData?.name)
                      }
                      title={userDetailData && userDetailData?.name}
                    >
                      {getShortLetters(userDetailData && userDetailData?.name)}
                    </span>
                  )}
                </div>
                <div className="flexgrow">
                  <TaggableEditor
                    dataEditorAdded={dataEditorAdded?dataEditorAdded:Commentdata}
                    onChangeAddEditor={onChangeAddEditor}
                    setDataEditorAdded={setDataEditorAdded}
                    cardDetail={cardDetail}
                  />
                  <button
                    className="mt-2 btn btn-light att-add d-inline-block"
                    onClick={handleAddDescription}
                    disabled={dataEditorAdded == '' ? true : false}
                  >
                    Save
                  </button>
                  <button
                    className="ml-3 mt-2 btn btn-light att-add d-inline-block"
                    onClick={() => setShowEditor((prev) => !prev)}
                  >
                    Close
                  </button>
                </div>
              </div>
            ))}
        </div>
      </div>

      <div className="modal-comments">
        {activityDate && activityDate?.length > 0
          ? activityDate.map((value) => {
              // console.log("attachmentssss",value);
              const fileName = value?.attachment?.file_name || '';
              const isImg = value?.attachment
                ? isImage(value?.attachment?.mime_type)
                : false;
              const fileUrl =
                isImg == true
                  ? `${UTILS.images_url}original/${fileName}`
                  : `${UTILS.images_url}original/${fileName}`;
              // const fileUrl = `${UTILS.images_url}original/${fileName}`;
              // console.log("value__", value);
              return value?.activity_type == 0 ? (
                <div class="coment-div new-comments new-activity-move normal-activity">
                  {value?.activity_user != null ? (
                    <div class="por-small">
                      <span
                        class={
                          'member-avatar color' +
                          getUserColor(
                            value?.activity_user && value?.activity_user?.name
                          )
                        }
                        title={
                          value?.activity_user && value?.activity_user?.name
                        }
                      >
                        {getShortLetters(
                          value?.activity_user && value?.activity_user?.name
                        )}
                      </span>
                    </div>
                  ) : (
                    ''
                  )}

                  <div class="comment-box">
                    <div class="form-group">
                      <div class="show-activity">
                        <div class="upd-name-activity">
                          {/* <span class="upd-name">
                                {value?.activity_user?.name}
                              </span>
                              <span class="upd-name-text mb-0">
                                <span class="attachment-span pdf3">
                                  {value?.activity}
                                </span>
                              </span>
                              <span class="upd-date">{value?.created_at}</span> */}
                          <div class="upd-name-div">
                            <div class="mb-0">
                              <span class="upd-name">
                                {value?.activity_user?.name}
                              </span>{' '}
                              <span class="attachment-span pdf3">
                                {value?.activity}
                              </span>
                            </div>
                            <span class="upd-date">{value?.created_at}</span>
                          </div>
                          <>
                            {editorId === value?.comment?.id ? (
                              <>
                                <Editor
                                  ref={editorRef}
                                  value={html}
                                  onChange={handleEditorChange}
                                />
                                {/* {showDropdown && (
                                        <div
                                          style={{
                                            ...dropdownStyle,
                                            top: dropdownPosition.top,
                                            left: dropdownPosition.left,
                                          }}
                                          className="board-members-list member-assignment mentionList"
                                        >
                                          {suggestions.map((person, index) => (
                                            <div
                                              key={index}
                                              onClick={() => handleSelectPerson(person)}
                                              style={dropdownItemStyle}
                                              className="assign-unassign-members mentionLi"
                                            >
                                              <span className={`nameCir color${getUserColor(person)}`}>
                                                {getShortLetters(person)}
                                              </span>
                                              <div className="membr-list-name">{person}</div>
                                            </div>
                                          ))}
                                        </div>
                                      )} */}
                                {showDropdown && (
                                  <Select
                                    options={suggestions.map((person) => ({
                                      value: person,
                                      label: person,
                                    }))}
                                    onChange={handleSelectChange}
                                    style={{
                                      position: 'absolute',
                                      top: dropdownPosition.top,
                                      left: dropdownPosition.left,
                                      zIndex: 1000,
                                      width: '200px',
                                    }}
                                    // options={{
                                    //   placeholder: 'Select a person...',
                                    //   noResultsText: 'No results found',
                                    //   width: '100%',
                                    // }}
                                  />
                                )}

                                {/*                                 
                                  <TaggableEditor
                                    dataEditorAdded={html || value?.comment?.comment}
                                    onChangeAddEditor={onChange}
                                    setDataEditorAdded={setDataEditorAdded}
                                  /> */}
                                <button
                                  className="mt-2 btn btn-light att-add d-inline-block"
                                  onClick={fetchUpdateComments}
                                >
                                  Edit
                                </button>
                                <button
                                  className="ml-3 mt-2 btn btn-light att-add d-inline-block"
                                  onClick={() => setEditorId(false)} // Close "Edit" editor
                                >
                                  Close
                                </button>
                              </>
                            ) : (
                              <>
                                <div className="upd-comment-div">
                                  <div
                                    className="avtivityArea"
                                    dangerouslySetInnerHTML={{
                                      __html: value?.comment?.comment,
                                    }}
                                  />
                                </div>
                                <div className="upd-crud-list">
                                  {userDetailData?.id ==
                                    value?.activity_user?.id && (
                                    <ul className="crud-list mt-2">
                                      <li className="activityCrud">
                                        <div
                                          className="comment-edit-link crudStyle"
                                          onClick={() =>
                                            getSpecificId(
                                              value?.comment.id,
                                              value?.comment?.comment
                                            )
                                          }
                                        >
                                          Edit
                                        </div>
                                      </li>
                                      <li className="activityCrud">
                                        <div
                                          className="comment-delete-link crudStyle"
                                          onClick={() =>
                                            onDeleteFunc(value?.comment?.id)
                                          }
                                        >
                                          Delete
                                        </div>
                                      </li>
                                    </ul>
                                  )}
                                </div>
                              </>
                            )}
                          </>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : value?.activity_type === 1 && attachmentsFile?.length > 0 ? (
                <div class="coment-div new-comments new-activity-move normal-activity">
                  <div class="por-small">
                    <span
                      class="member-avatar color3"
                      title={value?.activity_user?.name}
                    >
                      {getShortLetters(value?.activity_user?.name)}
                    </span>
                  </div>
                  <div class="comment-box">
                    <div class="form-group">
                      <div class="activity-details">
                        <div class="activityName">
                          <div>
                            <span class="upd-name user-link">
                              {value?.activity_user?.name}
                            </span>{' '}
                            <span class="attachment-span pdf12s">
                              attached
                              {isImg && value?.attachment ? (
                                <>
                                  <a
                                    // href={fileUrl}
                                    href={
                                      isRecent(value?.created_at, 10)
                                        ? UTILS.images_url +
                                          'original/' +
                                          value?.attachment?.file_name
                                        : UTILS.temp_image_url +
                                          'original/' +
                                          value?.attachment?.file_name
                                    }
                                    className="attachment-link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-attachment-id={value?.attachment?.id}
                                    data-fancybox="gallery"
                                  >
                                    <span>
                                      {value?.attachment?.original_name}
                                    </span>{' '}
                                  </a>
                                  <span className="time-span">
                                    to this card
                                  </span>{' '}
                                  <span className="upd-date">
                                    {value?.attachment?.created_at}
                                  </span>
                                </>
                              ) : (
                                <>
                                  <a
                                    href={
                                      'https://trelloassets.tgcrm.net/downloadassets.php?url=' +
                                      (isRecent(value?.created_at, 10)
                                        ? UTILS.images_url +
                                          'original/' +
                                          value?.attachment?.file_name
                                        : UTILS.temp_image_url +
                                          'original/' +
                                          value?.attachment?.file_name) +
                                      '&filename=' +
                                      encodeURIComponent(
                                        value?.attachment?.original_name
                                      )
                                    }
                                    //  href={
                                    //   isRecent(value?.created_at,10)
                                    //   ? UTILS.images_url + "original/" + value?.attachment?.file_name
                                    //   : UTILS.temp_image_url + "original/" + value?.attachment?.file_name
                                    // }
                                    // href={fileUrl}
                                    className="attachment-link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-attachment-id={value?.attachment?.id}
                                  >
                                    <span className="file-icon">
                                      {getFileIcon(fileName)}
                                    </span>
                                    <span>
                                      {value?.attachment?.original_name}
                                    </span>
                                  </a>
                                  <span className="time-span">
                                    to this card
                                  </span>{' '}
                                  <span className="upd-date">
                                    {value?.attachment?.created_at}
                                  </span>
                                </>
                              )}
                            </span>
                          </div>
                        </div>
                        {isImg ? (
                          <a
                            // href={fileUrl}
                            href={
                              'https://trelloassets.tgcrm.net/downloadassets.php?url=' +
                              (isRecent(value?.created_at, 10)
                                ? UTILS.images_url +
                                  'original/' +
                                  value?.attachment?.file_name
                                : UTILS.temp_image_url +
                                  'original/' +
                                  value?.attachment?.file_name) +
                              '&filename=' +
                              encodeURIComponent(
                                value?.attachment?.original_name
                              )
                            }
                            // href={
                            //   isRecent(value?.created_at,10)
                            //   ? UTILS.images_url + "original/" + value?.attachment?.file_name
                            //   : UTILS.temp_image_url + "original/" + value?.attachment?.file_name
                            // }
                            className="attachment-link"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-attachment-id={value?.attachment?.id}
                            data-fancybox="gallery"
                          >
                            <img
                              className="activity-image"
                              // src={fileUrl}
                              // src={
                              //   isRecent(value?.created_at, 10)
                              //     ? UTILS.images_url +
                              //       '150x150/' +
                              //       value?.attachment?.file_name
                              //     : UTILS.temp_image_url +
                              //       '150x150/' +
                              //       value?.attachment?.file_name
                              // }
                              src={
                                isRecent(value?.created_at, 10)
                                  ? UTILS.images_url +
                                    (value?.attachment?.file_name?.toLowerCase().endsWith('.gif') ? 'original/' : '150x150/') +
                                    value?.attachment?.file_name
                                  : UTILS.temp_image_url +
                                    (value?.attachment?.file_name?.toLowerCase().endsWith('.gif') ? 'original/' : '150x150/') +
                                    value?.attachment?.file_name
                              }
                              alt={value?.attachment?.original_name}
                            />
                            {/* <span>{value?.attachment?.original_name}</span> */}
                          </a>
                        ) : (
                          <a
                            // href={fileUrl}
                            href={
                              'https://trelloassets.tgcrm.net/downloadassets.php?url=' +
                              (isRecent(value?.created_at, 10)
                                ? UTILS.images_url +
                                  'original/' +
                                  value?.attachment?.file_name
                                : UTILS.temp_image_url +
                                  'original/' +
                                  value?.attachment?.file_name) +
                              '&filename=' +
                              encodeURIComponent(
                                value?.attachment?.original_name
                              )
                            }
                            // href={
                            //   isRecent(value?.created_at,10)
                            //   ? UTILS.images_url + "original/" + value?.attachment?.file_name
                            //   : UTILS.temp_image_url + "original/" + value?.attachment?.file_name
                            // }
                            className="attachment-link"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-attachment-id={value?.attachment?.id}
                          >
                            <span className="file-icon">
                              {getFileIcon(fileName)}{' '}
                              {value?.attachment?.original_name}
                            </span>
                            <span>{value?.attachment?.original_name}</span>
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : value?.activity_type == 2 ? (
                hideActivity ? (
                  <>
                    {' '}
                    {/* <span>{value?.id}</span> */}
                    <div class="coment-div new-comments new-activity-move normal-activity">
                      <div class="por-small">
                        <span
                          class={
                            'member-avatar color' +
                            getUserColor(value?.activity_user?.name)
                          }
                          title="Lutfi Ahmed"
                        >
                          {getShortLetters(value?.activity_user?.name)}
                        </span>
                      </div>
                      <div class="comment-box">
                        <div class="form-group">
                          <div class="show-activity">
                            <div class="upd-name-activity">
                              <div class="upd-name-div">
                                <div class="mb-0">
                                  <span class="upd-name">
                                    {value?.activity_user?.name}
                                  </span>{' '}
                                  <span class="attachment-span pdf1">
                                    {value?.activity}
                                  </span>
                                </div>
                                <span class="upd-date">
                                  {value?.created_at}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ''
                )
              ) : (
                ''
              );
            })
          : ''}
      </div>
    </div>
  );
};
// Styling for the dropdown
const dropdownStyle = {
  position: 'absolute',
  border: '1px solid #ddd',
  background: '#fff',
  zIndex: 1000,
  maxHeight: '150px',
  overflowY: 'auto',
  width: '200px',
  boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
};

const dropdownItemStyle = {
  padding: '8px',
  cursor: 'pointer',
  borderBottom: '1px solid #eee',
};
